import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import { EditRequirementAction } from "../types";

/** A helper function that determines if a user can perform
 * an action for an object with an availableActions attribute */
export function canPerformAction(resource, actionName) {
  var _resource$availableAc;
  return !!((_resource$availableAc = resource.availableActions) !== null && _resource$availableAc !== void 0 && _resource$availableAc.some(function (action) {
    return action.id === actionName;
  }));
}

/** A helper function that determines if a user can perform
 * an action for an object with an availableActions attribute */
export function canUpdateReqAttribute(requirement, attributeName) {
  var _requirement$availabl, _parsedEditAction$dat, _parsedEditAction$dat2;
  var editAction = (_requirement$availabl = requirement.availableActions) === null || _requirement$availabl === void 0 ? void 0 : _requirement$availabl.find(function (action) {
    return action.id === 'edit';
  });
  var parsedEditAction = EditRequirementAction.safeParse(editAction);
  if (!parsedEditAction.success) {
    return false;
  }
  return !!((_parsedEditAction$dat = parsedEditAction.data.additionalInformation) !== null && _parsedEditAction$dat !== void 0 && (_parsedEditAction$dat2 = _parsedEditAction$dat.mutableAttributes) !== null && _parsedEditAction$dat2 !== void 0 && _parsedEditAction$dat2.find(function (attribute) {
    return attribute.name === attributeName;
  }));
}